var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4977 12.6536H1.96422C1.866 12.6536 1.78564 12.734 1.78564 12.8322V14.1715C1.78564 14.2697 1.866 14.35 1.96422 14.35H15.4731L12.2522 18.4349C12.1606 18.5509 12.2432 18.725 12.3928 18.725H14.0111C14.1205 18.725 14.2231 18.6759 14.2923 18.5889L18.0602 13.8099C18.4285 13.3411 18.0959 12.6536 17.4977 12.6536ZM18.0356 7.38574H4.52672L7.7477 3.30092C7.83922 3.18485 7.75663 3.01074 7.60707 3.01074H5.98877C5.87939 3.01074 5.77672 3.05985 5.70752 3.1469L1.93966 7.92592C1.57136 8.39467 1.90395 9.08217 2.49993 9.08217H18.0356C18.1339 9.08217 18.2142 9.00181 18.2142 8.9036V7.56431C18.2142 7.4661 18.1339 7.38574 18.0356 7.38574Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.94882320d6897db38c7570135c3b0273.svg";
export { ForwardRef as ReactComponent };